type ZitchaSource = 'web' | 'app' | 'mobile';
type ZitchaChannel = 'unknown' | 'desktop' | 'mobile';
type ZitchaCreative = {
  headline?: {
    text: string;
  };
  subtitle?: {
    text: string;
  };
  cta?: {
    text: string;
    url: string;
  };
  url: string;
} & {
  [key in ZitchaChannel]?: Array<ZitchaBannerCreative>;
} & Record<string, unknown>;

type ZitchaBannerCreative = {
  image: string;
  width: number;
  height: number;
  alt: string;
};

export type ZitchaBanner = {
  adId: string;
  placement: Array<string>;
  channels: Array<ZitchaChannel>;
  creative: ZitchaCreative;
};

export type ZitchaBannerContainerProps = {
  location: string;
  banner: ZitchaBanner;
};

type ZitchaCustomerIdentifier = {
  type:
    | 'email'
    | 'emailhash_md5'
    | 'emailhash_sha1'
    | 'emailhash_sha256'
    | 'hash'
    | 'uuid'
    | 'customer_id'
    | 'crm_id'
    | 'loyalty_id'
    | 'username'
    | 'browser_id'
    | 'device_id'
    | 'device_fingerprint'
    | 'session_id';
  value: string;
  system: 'global' | 'local' | 'crm' | 'loyalty_program';
};

export type ZitchaCollectConversion = {
  event: 'conversions';
  data: {
    customerIdentifiers: Array<ZitchaCustomerIdentifier>;
    action?: 'sale' | 'checkout' | 'signup' | 'add-to-cart';
    basket: {
      currency: string;
      products: Array<{ productId: string; productName: string; pricePaid: number; quantity: number }>;
      value: number;
    };
    conversionId: string;
    pageLocation: string;
    retailerOrderId: string;
    source: ZitchaSource;
  };
};

export type ZitchaCollectClick = {
  event: 'ad-clicks';
  data: {
    adId: string;
    adFormat: 'native_banner' | 'native_product' | 'brand_store';
    clickId: string;
    customerIdentifiers: Array<ZitchaCustomerIdentifier>;
    pageViewId: string;
    pageLocation: string;
    placementId: string;
    source: ZitchaSource;
  };
};

export type ZitchaCollectImpression = {
  event: 'ad-impressions';
  data: {
    adId: string;
    adFormat: 'native_banner' | 'native_product' | 'brand_store';
    customerIdentifiers: Array<ZitchaCustomerIdentifier>;
    pageViewId: string;
    pageLocation: string;
    placementId: string;
    source: ZitchaSource;
  };
};

export type ZitchaCollectPageView = {
  event: 'page-view';
  data: {
    customerIdentifiers: Array<ZitchaCustomerIdentifier>;
    pageViewId: string;
    pageLocation: string;
    source: ZitchaSource;
  };
};
